/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Storytelling
 * (C) Copyright IBM Corp. 2014, 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'baglass/core-client/js/core-client/ui/core/Class',
	'underscore'
], function(Class, _) {

	/**
	 * Base controller for scene transitions.
	 * Rejects calls while transitions are in progress.
	 * Subclasses override '_next' and '_previous' to perform transitions
	 */
	const TransitionController = Class.extend({

		_deck: [],

		init: function() {
			TransitionController.inherited('init', this, arguments);
		},

		jumpTo: function(from, to) {
			return this._beforeJump(from, to)
				.then(() => this._jump(from, to))
				.then(() => this._afterJump(from, to))
				.then(() => ({ overview: to.id === 'end' || to.id === 'start' }))
				.catch((err) => {
					return this._afterJump(from, to)
						.then(() => Promise.reject(err));
				});
		},

		forward: function(from, to) {
			return this._beforeNext(from, to)
				.then(() => this._next(from, to))
				.then(() => this._afterNext(from, to))
				.then(() => ({ overview: false }));
		},

		backward: function(from, to) {
			return this._beforePrevious(from, to)
				.then(() => this._previous(from, to))
				.then(() => this._afterPrevious(from, to))
				.then(() => ({ overview: false }));
		},

		_beforeJump: function(from, to) {
			this._setNextSceneScrollPosition(from, to);
			return Promise.resolve();
		},

		_jump: function() {
			return Promise.resolve();
		},

		_afterJump: function() {
			return Promise.resolve();
		},

		_beforeNext: function(from, to) {
			this._setNextSceneScrollPosition(from, to);
			return Promise.resolve();
		},

		_next: function() {
			return Promise.resolve();
		},

		_afterNext: function() {
			return Promise.resolve();
		},

		_beforePrevious: function(from, to) {
			this._setNextSceneScrollPosition(from, to);
			return Promise.resolve();
		},

		_previous: function() {
			return Promise.resolve();
		},

		_afterPrevious: function() {
			return Promise.resolve();
		},

		_setNextSceneScrollPosition: function(from, to) {
			if(from && to && from.getLayoutView && to.getLayoutView) {
				var fromSceneScrollPosition = from.getLayoutView().$el.scrollTop();
				to.getLayoutView().$el.scrollTop(fromSceneScrollPosition);
			}
		},

		deckScenes: function(scenes) {
			let setOnDeck = ($el) => {
				if($el.length) {
					$el.addClass('onDeck');
					$el.removeClass('hiddenScene');
				}
			};
			_.each(scenes, (scene) => {
				setOnDeck(scene.$el);
				this._showWidgets(scene);
				this._hideWidgets(scene);
			});
			this._deck = scenes;
		},

		undeckScenes: function(scenes) {
			let setOffDeck = ($el) => {
				if($el.length) {
					$el.removeClass('onDeck');
					$el.addClass('hiddenScene');
					$el.attr('aria-hidden', 'true');
				}
			};
			_.each(scenes, (scene) => {
				if(!this._deck.includes(scene)) {
					setOffDeck(scene.$el);
				}
			});
		},

		_hideWidgets: function(view) {
			if(view && view.getLayoutView) {
				view.getLayoutView().onHide();
			}
		},

		_showWidgets: function(view) {
			if(view && view.getLayoutView) {
				view.getLayoutView().onShow();
			}
		}
	});

	return TransitionController;
});
